module.exports = __webpack_public_path__ + "fonts/Manrope-400-cyrillic-ext1_6b3b5bc.woff2";